import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import BootstrapVue, { BootstrapVueIcons } from 'bootstrap-vue'
// import { ValidationProvider, extend } from 'vee-validate'
import { ValidationProvider, extend, localize } from 'vee-validate'
// import KnobControl from 'vue-knob-control'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import VueSignaturePad from 'vue-signature-pad'
// import Vuebar from 'vuebar'
import en from 'vee-validate/dist/locale/en.json'

// CSS
// import 'vue2-timepicker/dist/VueTimepicker.css'
import * as rules from 'vee-validate/dist/rules'
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule])
})

localize('en', en)
// Vue.use(KnobControl)
// Vue.use(Vuebar)

Vue.use(BootstrapVueIcons)

Vue.component('ValidationProvider', ValidationProvider)
// Vue.component(' ValidationObserver', ValidationObserver)
Vue.use(BootstrapVue)
// Vue.use(VueSignaturePad)
// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (window.Cypress) {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running inside Cypress...
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
